import { useMe } from '@/common/entities/me/model/me'
import { useAcceptInvitation, useInvitationInfo } from '../models/orgInvitationsModel'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Button } from '@/common/ui/Form/Button'
import { useLogout } from '@/app/entities/auth/model/logout'
import { RegistrationFormWithInvite } from '@/app/entities/auth/ui/registration/RegistrationFormWithInvite'
import { ROUTES } from '@/app/app/routing/routes'

export const InvitationAcceptForm = () => {
    const navigate = useNavigate()
    const { me } = useMe()

    const [searchParams] = useSearchParams()
    const token = searchParams.get('token') ?? ''

    const { invitationInfo, isSameUser, isValidToken, isRegistrationForm, isLoading } = useInvitationInfo(token)
    const email = invitationInfo?.email ?? ''
    const redirectPath = `/app/invitations?token=${token}`
    const logoutMutation = useLogout({ redirect: redirectPath, email })
    const logoutWithoutRedirectMutation = useLogout({ noRedirect: true })

    const logoutHandler = (e: React.FormEvent) => {
        e.preventDefault()
        logoutMutation.mutate()
    }
    const logoutAndRegisterHandler = (e: React.FormEvent) => {
        e.preventDefault()
        logoutWithoutRedirectMutation.mutate()
        navigate(`/app/invitations?token=${token}`)
    }

    const loginHandler = (e: React.FormEvent) => {
        e.preventDefault()
        const queryParams = new URLSearchParams({ redirect: redirectPath })
        if (email) {
            queryParams.set('email', email)
        }
        navigate(`${ROUTES.AUTH.LOGIN}?${queryParams.toString()}`)
    }
    if (isLoading) {
        return <div>Загрузка...</div>
    }

    if (!isValidToken) {
        return <div>Приглашение недоступно или истекло</div>
    }
    if (isRegistrationForm && invitationInfo && invitationInfo.email && token) {
        return (
            <div className='w-full flex flex-col gap-[1.875rem]'>
                <h2 className='text-2xl text-center'>Зарегистрируйтесь, чтобы принять приглашение</h2>
                <p>Название организации: {invitationInfo.organization_name}</p>

                <RegistrationFormWithInvite email={invitationInfo.email} inviteToken={token} />
            </div>
        )
    }
    if (typeof me === 'undefined' && !isSameUser && invitationInfo) {
        return (
            <div className='w-full flex flex-col gap-[1.875rem]'>
                <h1>
                    Войдите под аккаунтом
                    <br />
                    {invitationInfo.email}
                    <br />
                    чтобы принять приглашение.
                </h1>
                <Button size='xl' className='w-full' onClick={loginHandler}>
                    Войти
                </Button>
            </div>
        )
    }
    if (typeof me !== 'undefined' && !isSameUser && invitationInfo && invitationInfo.user_exists) {
        return (
            <div className='w-full flex flex-col gap-[1.875rem]'>
                <h1>
                    Войдите под аккаунтом
                    <br /> {invitationInfo.email}
                    <br />
                    чтобы принять приглашение
                </h1>

                <Button size='xl' className='w-full' onClick={logoutHandler}>
                    Выйти из текущего аккаунта
                </Button>
            </div>
        )
    }

    if (typeof me !== 'undefined' && !isSameUser && invitationInfo && !invitationInfo.user_exists) {
        return (
            <div className='w-full flex flex-col gap-[1.875rem]'>
                <h1>
                    Войдите под аккаунтом
                    <br /> {invitationInfo.email}
                    <br />
                    чтобы принять приглашение
                </h1>

                <Button size='xl' className='w-full' onClick={logoutAndRegisterHandler}>
                    Выйти и зарегистрироваться
                </Button>
            </div>
        )
    }

    return (
        <div className='w-full flex flex-col gap-[1.875rem]'>
            <h2 className='text-2xl text-center'>Примите приглашение</h2>
            <p>Название организации: {invitationInfo?.organization_name}</p>
            <p>Вас пригласил: {invitationInfo?.invited_by_name}</p>
            <InvitationAcceptFormWithMutation org_id={invitationInfo?.org_id || ''} token={token} />
        </div>
    )
}

export type InvitationAcceptFormWithMutationProps = {
    org_id: string
    token: string
}

export const InvitationAcceptFormWithMutation = ({ org_id, token }: InvitationAcceptFormWithMutationProps) => {
    const { handleSubmit, onSubmit, isLoading, errors } = useAcceptInvitation(org_id, token)

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            aria-label='Форма принятия приглашения'
            className='w-full flex flex-col gap-[1.875rem]'
        >
            {errors.root && <div className='input-error text-center text-sm'>{errors.root.message}</div>}
            <Button
                type='submit'
                className='w-full'
                emphasis='accent'
                size='xl'
                aria-label='Принять приглашение'
                disabled={isLoading}
            >
                {isLoading ? <span className='loading loading-spinner loading-xs mr-2'></span> : null}
                Принять приглашение
            </Button>
        </form>
    )
}
